if (!customElements.get("color-swatch")) {
  customElements.define(
    "color-swatch",
    class ColorSwatch extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initialize();
      }

      initialize() {
        this.initProperites();
        this.initButtons();
        this.initCounter();
      }

      initProperites() {
        const node = this;
        this.isProductVariations = node.dataset.productVariations === '';
        this.areFiltersActive = node.dataset.activeFilters === '';
        this.container = node.querySelector(".card__container");
        this.adnotation = node.querySelector(".card");
        this.titleAdnotation = node.querySelector(".card__title a");
        this.color_swatcher_container = this.container.querySelector(
          ".card__color-swatcher--container",
        );
        this.color_swatcher_wrappers = this.container.querySelectorAll(
          ".color-swatcher--wrapper",
        );
        this.color_swatcher_counter = this.container.querySelector(
          ".color-swatcher--counter",
        );
        this.img =
          this.container.querySelector(
            ".card__desktop-images .card__img:not(.card__img--hover)",
          ) || this.container.querySelector(".card__img");
        this.hover_img = this.container.querySelector(".card__img--hover");
        this.mobileGallery = this.container.querySelector("[data-mobile-gallery]");
        this.mobileGalleryTrack = this.mobileGallery?.querySelector(
          ".card__mobile-gallery-track",
        );
        this.mobileGalleryDots =
          this.mobileGallery?.querySelectorAll(".card__mobile-gallery-dot");
        this.mobilePrimaryImage =
          this.mobileGallery?.querySelector("[data-mobile-gallery-primary]") ||
          this.mobileGallery?.querySelector(".card__img");
        this.titleEl = node.querySelector(".card__title");
        this.video = this.querySelector("video");
        this.clicked_href = this.adnotation.getAttribute("href");
        this.clicked_img = this.img?.getAttribute("src");
        this.clicked_srcset = this.img?.getAttribute("srcset");
        this.clicked_hover_img = this.hover_img?.getAttribute("src");
        this.clicked_hover_srcset= this.hover_img?.getAttribute("srcset");
        this.clicked_mobile_gallery = this.captureMobileGalleryFromDom();
        this.clicked_mobile_img =
          this.clicked_mobile_gallery[0]?.src ||
          this.mobilePrimaryImage?.getAttribute("src");
        this.clicked_mobile_srcset =
          this.clicked_mobile_gallery[0]?.srcset ||
          this.mobilePrimaryImage?.getAttribute("srcset");
        if (!this.clicked_mobile_gallery.length && this.clicked_mobile_img) {
          this.clicked_mobile_gallery = [
            {
              src: this.clicked_mobile_img,
              srcset: this.clicked_mobile_srcset,
              alt: this.mobilePrimaryImage?.getAttribute("alt"),
              width: this.mobilePrimaryImage?.getAttribute("width"),
              height: this.mobilePrimaryImage?.getAttribute("height"),
            },
          ];
        }
        this.quickAdds = this.querySelectorAll("quick-add");

        this.loader = this.querySelector(".card__loader");

        
        this.optionsAsColorSwatches = this.color_swatcher_container?.dataset.optionsAsColorSwatches?.split(",") || [];
      }

      initCounter() {
        if (this.color_swatcher_wrappers?.length > 4) {
          this.color_swatcher_counter.innerHTML += `+ ${this.color_swatcher_wrappers.length - 4}`;
          this.color_swatcher_container.addEventListener("mouseover", () =>
            this.showAllWrappers(),
          );
        }
      }

      showAllWrappers() {
        this.color_swatcher_wrappers.forEach((wrapper) =>
          wrapper.classList.remove("hidden"),
        );
        this.color_swatcher_counter.classList.add("hidden");
      }

      initButtons() {
        this.isCheckedOption = 0;
        this.isCheckedActiveFilter = false;
        
        if (this.color_swatcher_wrappers) {
          this.sortButtons();
          this.color_swatcher_wrappers.forEach((wrapper, index) => {
            const button = wrapper.querySelector(".color-swatcher");
            const attributes = this.getButtonAttributes(button);
            const tooltip = wrapper.querySelector(".color-swatcher--tooltip");
            
            if (index > 3) {
              wrapper.classList.add("hidden");
            }
            
            // find filter color and preselect it 
            if(!this.isCheckedActiveFilter){
              const isActiveSwatch = button.dataset.activeSwatch === '';

              if(this.isProductVariations && this.areFiltersActive){
                const currentVariantHandle = this.dataset.currentVariantHandle;
                if(currentVariantHandle === attributes.button_product_handle){
                  this.handleClickEvent(wrapper, attributes)
                  this.isCheckedActiveFilter = true;
                }
              } else if (isActiveSwatch) {
                  this.handleClickEvent(wrapper, attributes)
                  this.isCheckedActiveFilter = true;
              }
          }

            this.assignWrapperEvents(wrapper, attributes, tooltip);
          });
        }

        if (this.color_swatcher_container) {
          this.color_swatcher_container.addEventListener("mouseleave", () =>
            this.restoreAttributes(),
          );
        }
      }

      getButtonAttributes(button) {
        return {
          dataColor: button.getAttribute("data-color"),
          button_href: button.getAttribute("data-href"),
          button_img: button.getAttribute("data-img"),
          button_srcset: button.getAttribute("data-srcset"),
          button_hover: button.getAttribute("data-hover"),
          button_hover_srcset: button.getAttribute("data-hover-srcset"),
          button_product_handle: button.getAttribute("data-product-handle"),
          gallery_images: this.getGalleryImages(button),
        };
      }

      assignWrapperEvents(wrapper, attributes, tooltip) {
        wrapper.addEventListener("click", () =>
          this.handleClickEvent(wrapper, attributes),
        );
        wrapper.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            this.handleClickEvent(wrapper, attributes);
          }
        });
        wrapper.addEventListener("mouseover", () =>
          this.handleMouseOverEvent(wrapper, attributes, tooltip),
        );
        wrapper.addEventListener("mouseout", () =>
          this.handleMouseOutEvent(tooltip),
        );
      }

      handleClickEvent(
        wrapper,
        {
          button_href,
          button_img,
          button_hover,
          button_srcset,
          button_hover_srcset,
          button_product_handle,
          gallery_images,
        },
      ) {
        if(!button_img) return

        this.showLoader();
        this.img.classList.remove("hidden");
        this.img.onload = () => {
          this.hideLoader();
          this.img.onload = null;
        };

        this.setAttributes(this.adnotation, { href: button_href });
        this.setAttributes(this.img, { src: button_img });
        this.setAttributes(this.img, { srcset: button_srcset });
        this.setAttributes(this.adnotation, { href: button_href });
        this.setAttributes(this.titleAdnotation, { href: button_href });

        this.quickAdds?.forEach((quickAdd) => {
          quickAdd.setAttribute("data-product-handle", button_product_handle);
          quickAdd.querySelector("button").dataset.productUrl = button_href;
        });

        if(this.price) this.price.innerHTML = button_price;
        this.checkHoverImage(button_hover, button_hover_srcset);
        this.color_swatcher_wrappers.forEach((wrap) => {
          wrap.classList.remove("active");
        });
        this.clicked_href = button_href;
        this.clicked_img = button_img;
        this.clicked_srcset = button_srcset;
        this.clicked_hover_img = button_hover;
        this.clicked_hover_srcset = button_hover_srcset;
        const normalized_gallery =
          gallery_images?.length > 0
            ? gallery_images
            : [
                {
                  src: button_img,
                  srcset: button_srcset,
                  alt: this.img?.getAttribute("alt"),
                  width: this.img?.getAttribute("width"),
                  height: this.img?.getAttribute("height"),
                },
              ];
        this.updateMobileGallery(normalized_gallery);
        this.clicked_mobile_gallery = normalized_gallery;
        this.clicked_mobile_img = normalized_gallery[0]?.src || button_img;
        this.clicked_mobile_srcset =
          normalized_gallery[0]?.srcset || button_srcset;
        wrapper.classList.add("active");

        this.video?.classList.add("hidden");
        this.isVideoHidden = true;
      }

      showLoader() {
        this.loader.classList.remove("hidden");
        this.loader.innerHTML = '<div class="spinner-ring"></div>';
        if (!this.img) return;
        this.img.style.opacity = 0;
      }

      hideLoader() {
        this.loader.classList.add("hidden");
        this.loader.innerHTML = "";
        if (!this.img) return;
        this.img.style.opacity = 1;
      }

      handleMouseOverEvent(
        wrapper,
        { button_href, button_img, button_hover, button_srcset, button_hover_srcset },
        tooltip,
      ) {
        if(!this.img?.src?.includes(button_img) || this.img?.classList.contains("hidden")){
        this.showLoader();
        this.img.classList.remove("hidden");
        this.img.onload = () => {
          this.hideLoader();
          this.img.onload = null;
        };

        this.setAttributes(this.adnotation, { href: button_href });
        this.setAttributes(this.img, { src: button_img });
        this.setAttributes(this.img, { srcset: button_srcset });
        this.setAttributes(this.titleAdnotation, { href: button_href });
      }

        this.checkHoverImage(button_hover, button_hover_srcset);
        tooltip.classList.remove("hidden");
        this.setTooltipPosition(tooltip);
      }

      handleMouseOutEvent(tooltip) {
        tooltip.classList.add("hidden");
        tooltip.classList.remove(
          "color-swatcher--tooltip-left",
          "color-swatcher--tooltip-right",
        );
      }

      setTooltipPosition(tooltip) {
        const coords = tooltip.getBoundingClientRect();
        const screenWidth = window.innerWidth;

        if (!coords) return;

        if (coords.x < 0) {
          tooltip.classList.add("color-swatcher--tooltip-left");
        } else if (coords.right > screenWidth) {
          tooltip.classList.add("color-swatcher--tooltip-right");
        }
      }

      setFirstOptionActive() {
        const wrapper = this.color_swatcher_wrappers[0];
        if (wrapper) {
          const button = wrapper.querySelector(".color-swatcher");
          const attributes = this.getButtonAttributes(button);
          this.setAttributes(this.adnotation, { href: attributes.button_href });
          this.setAttributes(this.titleAdnotation, { href: attributes.button_href });
          this.setAttributes(this.img, { src: attributes.button_img });
          this.setAttributes(this.img, { srcset: attributes.button_srcset });
          this.checkHoverImage(attributes.button_hover, attributes.button_hover_srcset);
          wrapper.classList.add("active");
        }
      }

      restoreAttributes() {
        this.setAttributes(this.adnotation, { href: this.clicked_href });
        this.setAttributes(this.titleAdnotation, { href: this.clicked_href });
        this.setAttributes(this.img, { src: this.clicked_img });
        this.setAttributes(this.img, { srcset: this.clicked_srcset });
        this.checkHoverImage(this.clicked_hover_img, this.clicked_hover_srcset);
        this.updateMobileGallery(this.clicked_mobile_gallery || []);
      }

      sortButtons() {
        if (this.color_swatcher_wrappers) {
          const newArr = Array.from(this.color_swatcher_wrappers).sort(
            (a, b) => {
              const classA = a.classList?.contains("unavailable");
              const classB = b.classList?.contains("unavailable");
              return classA && !classB ? 1 : !classA && classB ? -1 : 0;
            },
          );

          if (this.color_swatcher_container) {
            this.color_swatcher_container.innerHTML = "";
          }

          newArr.forEach((el) => this.color_swatcher_container.append(el));
          this.createCounterSpan();
          this.color_swatcher_wrappers = this.container.querySelectorAll(
            ".color-swatcher--wrapper",
          );
          this.color_swatcher_counter = this.container.querySelector(
            ".color-swatcher--counter",
          );
        }
      }

      createCounterSpan() {
        const counter_span = document.createElement("span");
        counter_span.classList.add("color-swatcher--counter");
        this.color_swatcher_container?.appendChild(counter_span);
      }

      setAttributes(element, attrs) {
        for (let key in attrs) {
          element?.setAttribute(key, attrs[key]);
        }
      }

      checkHoverImage(button_hover, button_hover_srcset) {
        if (button_hover && this.hover_img) {
          this.setAttributes(this.hover_img, { src: button_hover });
          if (button_hover_srcset) {
            this.setAttributes(this.hover_img, { srcset: button_hover_srcset });
          }
        }
      }

      getGalleryImages(button) {
        const images = [];
        const limit = 4;

        for (let index = 1; index <= limit; index++) {
          const src = button.getAttribute(`data-gallery-image-${index}-src`);
          if (!src) continue;

          images.push({
            src,
            srcset:
              button.getAttribute(`data-gallery-image-${index}-srcset`) || "",
            alt: button.getAttribute(`data-gallery-image-${index}-alt`) || "",
            width:
              button.getAttribute(`data-gallery-image-${index}-width`) || "",
            height:
              button.getAttribute(`data-gallery-image-${index}-height`) || "",
          });
        }

        return images;
      }

      updateMobileGallery(images = []) {
        if (!this.mobileGallery) return;

        if (!this.mobileGalleryTrack) {
          const primaryImage = images[0];
          if (primaryImage) {
            this.mobilePrimaryImage =
              this.mobilePrimaryImage ||
              this.mobileGallery.querySelector(".card__img");
            this.setAttributes(this.mobilePrimaryImage, {
              src: primaryImage.src,
              alt:
                primaryImage.alt ||
                this.mobilePrimaryImage?.getAttribute("alt"),
            });
            if (primaryImage.srcset) {
              this.setAttributes(this.mobilePrimaryImage, {
                srcset: primaryImage.srcset,
              });
            }
            if (primaryImage.width) {
              this.setAttributes(this.mobilePrimaryImage, {
                width: primaryImage.width,
              });
            }
            if (primaryImage.height) {
              this.setAttributes(this.mobilePrimaryImage, {
                height: primaryImage.height,
              });
            }
            this.updateMobilePrimaryImage(
              primaryImage.src,
              primaryImage.srcset,
              { resetPosition: false },
            );
          } else {
            this.updateMobilePrimaryImage(
              this.clicked_mobile_img,
              this.clicked_mobile_srcset,
              { resetPosition: false },
            );
          }
          return;
        }

        const itemElements = Array.from(
          this.mobileGalleryTrack.querySelectorAll(".card__mobile-gallery-item"),
        );
        const imageElements = itemElements.map((item) =>
          item.querySelector(".card__img"),
        );
        const usableImages = images.slice(0, imageElements.length);

        imageElements.forEach((imgEl, index) => {
          const data = usableImages[index];
          if (data && imgEl) {
            this.setAttributes(imgEl, {
              src: data.src,
              alt: data.alt || imgEl.getAttribute("alt"),
            });
            if (data.srcset) {
              this.setAttributes(imgEl, { srcset: data.srcset });
            }
            if (data.width) {
              this.setAttributes(imgEl, { width: data.width });
            }
            if (data.height) {
              this.setAttributes(imgEl, { height: data.height });
            }
            imgEl.setAttribute("sizes", "100vw");
            imgEl.setAttribute("loading", index === 0 ? "eager" : "lazy");
            imgEl.removeAttribute("data-mobile-gallery-primary");
            itemElements[index]?.removeAttribute("hidden");
          } else {
            itemElements[index]?.setAttribute("hidden", "");
            imgEl?.removeAttribute("data-mobile-gallery-primary");
          }
        });

        if (usableImages.length > 0 && imageElements[0]) {
          imageElements.forEach((img) =>
            img?.removeAttribute("data-mobile-gallery-primary"),
          );
          imageElements[0].setAttribute("data-mobile-gallery-primary", "");
          this.mobilePrimaryImage = imageElements[0];
          this.updateMobilePrimaryImage(
            usableImages[0].src,
            usableImages[0].srcset,
            { resetPosition: false },
          );
        } else if (this.mobilePrimaryImage) {
          this.mobilePrimaryImage.removeAttribute("data-mobile-gallery-primary");
          this.updateMobilePrimaryImage(
            this.clicked_mobile_img,
            this.clicked_mobile_srcset,
            { resetPosition: false },
          );
        }

        this.mobileGalleryDots?.forEach((dot, index) => {
          if (usableImages[index]) {
            dot.removeAttribute("hidden");
          } else {
            dot.setAttribute("hidden", "");
            dot.classList.remove("active");
          }
        });

        this.resetMobileGalleryPosition();
      }

      captureMobileGalleryFromDom() {
        if (!this.mobileGallery) {
          return [];
        }

        if (this.mobileGalleryTrack) {
          return Array.from(
            this.mobileGalleryTrack.querySelectorAll(
              ".card__mobile-gallery-item .card__img",
            ),
          )
            .filter((img) => !img.closest("[hidden]"))
            .map((img) => ({
              src: img.getAttribute("src"),
              srcset: img.getAttribute("srcset"),
              alt: img.getAttribute("alt"),
              width: img.getAttribute("width"),
              height: img.getAttribute("height"),
            }));
        }

        if (this.mobilePrimaryImage) {
          return [
            {
              src: this.mobilePrimaryImage.getAttribute("src"),
              srcset: this.mobilePrimaryImage.getAttribute("srcset"),
              alt: this.mobilePrimaryImage.getAttribute("alt"),
              width: this.mobilePrimaryImage.getAttribute("width"),
              height: this.mobilePrimaryImage.getAttribute("height"),
            },
          ];
        }

        return [];
      }

      updateMobilePrimaryImage(src, srcset, { resetPosition = true } = {}) {
        if (!this.mobilePrimaryImage || !src) return;

        this.setAttributes(this.mobilePrimaryImage, { src });

        if (srcset) {
          this.setAttributes(this.mobilePrimaryImage, { srcset });
        }

        if (resetPosition) {
          this.resetMobileGalleryPosition();
        }
      }

      resetMobileGalleryPosition() {
        if (this.mobileGalleryTrack) {
          this.mobileGalleryTrack.scrollLeft = 0;
        }

        if (this.mobileGalleryDots?.length) {
          let isActiveSet = false;
          this.mobileGalleryDots.forEach((dot) => {
            if (!dot.hasAttribute("hidden") && isActiveSet === false) {
              dot.classList.add("active");
              isActiveSet = true;
            } else {
              dot.classList.remove("active");
            }
          });
        }
      }
    },
  );
}
